import React, { useCallback, useState } from 'react';
import { Popover, CircularProgress, Box } from '@mui/material';
import { useClient } from '../../../react-hooks/useClient';

const EmailWithContent = ({ params }) => {
    const item = params?.row ?? params?.value;
    const client = useClient();
    const [anchorEl, setAnchorEl] = useState(null);
    const [body, setBody] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchEmailContent = useCallback(async () => {
        if (body || loading) {
            return;
        }

        setLoading(true);

        if (item?.htmlMessage) {
            setBody(item.htmlMessage);
        } else if (item?.bodyUrl) {
            try {
                const response = await client.getClient().fetch(item.bodyUrl, {
                    method: 'GET',
                });
                setBody(await response.text());
            } catch (error) {
                console.error('Error fetching email content:', error);
            }
        }

        setLoading(false);
    }, [body, loading, item, client]);

    const handleMouseEnter = (event) => {
        setAnchorEl(event.currentTarget);
        fetchEmailContent();
    };

    const handleMouseLeave = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <div
            className="hoverable"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                style={{ wordWrap: 'break-word' }}
                dangerouslySetInnerHTML={{ __html: item?.subject }}
            />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleMouseLeave}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                disableRestoreFocus
                sx={{ pointerEvents: 'none' }}
                slotProps={{
                    paper: {
                        onMouseEnter: () => setAnchorEl(anchorEl),
                        onMouseLeave: handleMouseLeave,
                        sx: { pointerEvents: 'auto' },
                    },
                }}
            >
                <Box sx={{ p: 0, minWidth: 300, maxWidth: 600 }}>
                    {loading && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                            <CircularProgress size={24} />
                        </Box>
                    )}
                    {body && !loading && (
                        <iframe
                            className="email-message-body"
                            srcDoc={body}
                            title="email-message-body"
                            frameBorder="0"
                            scrolling="yes"
                            sandbox="allow-same-origin"
                            style={{ width: '100%', minHeight: 200, border: 'none' }}
                        />
                    )}
                </Box>
            </Popover>
        </div>
    );
};

export default EmailWithContent;
